import * as OBOApi from '../../api/obo-api';
import { IOBOAccount } from '../../models/obo-account';
import { IOBOOrderCertificates } from '../../models/obo-orderCertificates';
import { ISession } from '../../models/pro-sites';
import { IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_OBO_ACCOUNTS_SUCCESS = 'LOAD_OBO_ACCOUNTS_SUCCESS';
export const SET_OBO_ACCOUNT = 'SET_OBO_ACCOUNT';
export const SUBMIT_ORDER_CERTIFICATES_SUCCESS =
    'SUBMIT_ORDER_CERTIFICATES_SUCCESS';
export const SUBMIT_ORDER_CERTIFICATES_ERROR =
    'SUBMIT_ORDER_CERTIFICATES_ERROR';

//actions
export const loadOBOAccounts = (result: IResult<IOBOAccount>) => ({
    type: LOAD_OBO_ACCOUNTS_SUCCESS,
    result,
});

export const setOBOAccount = (result: IResult<ISession>) => ({
    type: SET_OBO_ACCOUNT,
    result,
});

export const submitOrderCertificatesSuccess = (result: IResult<boolean>) => ({
    type: SUBMIT_ORDER_CERTIFICATES_SUCCESS,
    result,
});

export const submitOrderCertificatesError = (error: any) => ({
    type: SUBMIT_ORDER_CERTIFICATES_ERROR,
    result: error,
});

//thunks
export const searchOBOAccount = (accountNumber: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await OBOApi.getOBOAccount(accountNumber);
            dispatch(loadOBOAccounts(result));
            return result;
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const submitOrderCertificatesOrder = (
    request: IOBOOrderCertificates
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await OBOApi.submitCertificatesOrder(request);
            dispatch(submitOrderCertificatesSuccess(result));
            return result;
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
